import Transform from '@ember-data/serializer/transform';

export default class ModelRunMemberTransform extends Transform {
  serialize() {
    console.log('ModelRunMemberTransform', ...arguments);
  }
  deserialize(serialized) {
    if (!serialized) {
      return null;
    }
    const result = {
      ...serialized,
      id: serialized._id,
    };
    delete result._id;
    return result;
  }
}
